import { AxiosResponse } from "axios"
import { IEntityGST, IGenericResponseGST, IPaginatedEntityGST } from "services/core/genericEntityGST"
import { RequestGST, RequestREAD } from "services/Instances"

export const WorkAccidentOccurrenceServices = () => {
  const path = 'Ocorrencia'

  const getByFilter = async (params: IGetOcorrenciasByFilterParams): Promise<AxiosResponse<IPaginatedEntityGST<IOcorrenciasByFilterItens[]>>> =>
    await RequestGST.get(`${path}/GetOcorrencias`, { params })

  const createOcorrencia = async (body: INewOccurrenceBody): Promise<AxiosResponse<IEntityGST<INewOccurrenceEntity>>> =>
    await RequestGST.post(`${path}`, body)

  const generateExcel = async (): Promise<AxiosResponse<IEntityGST<string>>> =>
    await RequestGST.get('Ocorrencia/GenerateExcel')

  const getOcorrenciaById = async (params: IGetOcorrenciaByIDParams): Promise<AxiosResponse<IEntityGST<IGetOcorrenciaByIDResponse>>> =>
    await RequestGST.get('Ocorrencia/GetOcorrenciaById', { params })

  const deleteOcorrencia = async (params: IDeleteOcorrenciaParams): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.delete('Ocorrencia', { params })

  return {
    createOcorrencia,
    deleteOcorrencia,
    generateExcel,
    getByFilter,
    getOcorrenciaById
  }
}

export const SupplierServices = () => {
  const path = 'Fornecedor'

  const getByCnpj = async (cnpj: string): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/GetByCnpj/${cnpj}`)

  return {
    getByCnpj
  }
}

export interface IDeleteOcorrenciaParams {
  idEntity: number
}

export const CentrosServices = () => {
  const path = 'CentroPlanta'

  const getCentroByEmpresaId = async (empresaId: number): Promise<AxiosResponse<ICentroPlantas>> =>
    await RequestGST.get(`${path}/FindByEmpresaId/${empresaId}`)

  const getAllCentroPlantas = async (): Promise<AxiosResponse<IEntityGST<IGetAllCentroPlantasResponse>>> =>
    await RequestGST.get(`${path}/PopularGrids`)

  const searchCentroPlanta = async (params: ISearchCentroPlantaParams): Promise<AxiosResponse<IEntityGST<ISearchCentroPlantaResponse[]>>> =>
    await RequestREAD.get('CentroPlanta/AutoComplete', {
      params: {
        hasDinamicSearch: true,
        nmCentroPlanta: params.nmCentroPlanta,
      }
    })

  return {
    getAllCentroPlantas,
    getCentroByEmpresaId,
    searchCentroPlanta
  }
}

export const EmpresasServices = () => {
  const path = 'Empresas'

  const getAllEmpresas = async (): Promise<AxiosResponse<IEntityGST<IEmpresasItens[]>>> =>
    await RequestGST.get(`${path}/ObterLista`)

  const searchEmpresa = async (params: ISearchEmpresaParams): Promise<AxiosResponse<IEntityGST<ISearchEmpresaResponse[]>>> =>
    await RequestREAD.get('Empresa/AutoComplete', { params })

  return {
    getAllEmpresas,
    searchEmpresa
  }
}

export interface ISearchEmpresaParams {
  nmEmpresa: string
  hasDinamicSearch: boolean
}

export interface ISearchEmpresaResponse {
  idEmpresa: number
  nmEmpresa: string
}

export interface IGetOcorrenciaByIDParams {
  idOcorrencia: number;
}

export interface IGetOcorrenciaByIDResponse {
  nuCompetencia: number;
  nmEmpresa: string;
  idCentro: number;
  nmCentro: string;
  cdTipoFornecedor: number;
  cdCnpjPassaporte: string;
  nmFornecedor: string;
  qtCaf: number;
  qtSaf: number;
  qtPs: number;
  qtDanoMaterial: number;
  qtAtendimentoAmb: number;
  qtTrajetoCaf: number;
  qtTrajetoSaf: number;
  qtTrajetoPs: number;
  qtIncendio: number;
  qtDiasPerdidos: number;
  qtTotalOcorrencias: number;
  qtTotalCafSafSp: number;
  hht: number;
}

export interface ISearchCentroPlantaParams {
  nmCentroPlanta: string
}

export interface ISearchCentroPlantaResponse {
  idCentroPlanta: number
  nmCentroPlanta: string
}

export interface IGetOcorrenciasByFilterParams {
  nuCompetenciaInicio?: string
  nuCompetenciaFim?: string
  txEmpresa?: string
  idCentroPlanta?: number
  cdTipoFornecedor?: number
  txCpfCnpjPassaporte?: string
  TxFornecedor?: string
  // ocorrenciaCAF?: string
  // ocorrenciaSAF?: string
  // diasPerdidos?: string
  // HHT?: string
  // taxaFrequenciaCAFSAF?: string
  // taxaFrequenciaCAF?: string
  // taxaGravidade?: string
  pageNumber?: number
  pageSize?: number
}

export interface INewOccurrenceBody {
  nuCompetencia: number;
  nmEmpresa: string;
  idCentro: number;
  cdTipoFornecedor: number;
  cdCnpjPassaporte: string;
  nmFornecedor: string;
  qtCaf: number;
  qtSaf: number;
  qtPs: number;
  qtDanoMaterial: number;
  qtAtendimentoAmb: number;
  qtTrajetoCaf: number;
  qtTrajetoSaf: number;
  qtTrajetoPs: number;
  qtIncendio: number;
  qtDiasPerdidos: number;
}

export interface INewOccurrenceEntity {
  idAcidenteTrab: number;
  contratoExternalId: number;
  nuCompetencia: number;
  nmEmpresa: string;
  cdDocto: string;
  cdTipoFornec: string;
  nmFornecedor: string;
  qtSaf: number;
  qtCaf: number;
  qtPs: number;
  qtTrajetoSaf: number;
  qtTrajetoCaf: number;
  qtTrajetoPs: number;
  qtDanoMaterial: number;
  qtAtendAmb: number;
  qtIncendio: number;
  qtDiasPerds: number;
  qtTotalSafCafPs: number;
  qtTtlOcorrencias: number;
}

export interface IOcorrenciasByFilterItens {
  idOcorrencia: number;
  nuAnoMesCompetencia: number;
  txEmpresa: string;
  txCentro: string;
  nmTipo: string;
  cdCpfCnpj: string;
  nmFornecedor: string;
}

export interface ICentroPlantas extends IGenericResponseGST {
  entity: ICentroPlantasItens[]
}

export interface ICentroPlantasItens {
  idCentroPlanta: number,
  txDescricaoCentroPlanta: string
}

export interface IEmpresasItens {
  empresaId: number;
  nmEmpresa: string;
}

export interface IGetAllCentroPlantasResponse {
  comValidacao: IGenericGetAllCentro[];
  semValidacao: IGenericGetAllCentro[];
}

export interface IGenericGetAllCentro {
  idCentroPlanta: number;
  empresaId: number;
  txDescricaoCentroPlanta: string;
  cdCentroCusto: string;
  cdCep: string;
  cdUF: string;
  nuCNAE: string;
  nuCNPJ: string;
  nuTelefone: string;
  txCidade: string;
  txEndereco: string;
  dtUltimaAtualizaçãoSap: string;
  dtAtualizaçãoSap: string;
  flNecessitaValidacao: boolean;
}
